import keyMirror from 'keymirror';

export const WhatsNewActionTypes = keyMirror({
  GET_WHATS_NEW: undefined,
  SET_WHATS_NEW: undefined,
  OPEN_WHATS_NEW: undefined,
  CLOSE_WHATS_NEW: undefined,
  DISMISS_WHATS_NEW: undefined,
  MARK_WHATS_NEW_SEEN: undefined,
});
